import { InfoCircleOutlined } from '@ant-design/icons';
import { AppRadioGroup } from '@xbcb/form-item-components';
import { Button, Table } from 'antd';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_5};
`;

export const StyledDiv = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
  .anticon-close-circle {
    margin-right: ${({ theme }) => theme.spacing.space_3};
    color: ${({ theme }) => theme.palette.status.bad};
  }
`;

export const StyledUploadDragContainer = styled.div`
  margin: 0 ${({ theme }) => theme.spacing.space_4};
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledUploadButton = styled(Button)`
  margin-right: ${({ theme }) => theme.spacing.space_3};
`;

export const StyledTable = styled(Table)`
  width: ${({ theme }) => theme.spacing.space_10};
  margin: ${({ theme }) => theme.spacing.space_3} 0;
  && thead > tr > th {
    padding: ${({ theme }) => theme.spacing.space_3} 0;
    background: none;
    border: none;
    font-weight: 400;
  }
  && thead > tr > th::before {
    background: none !important;
  }
  && tbody > tr > td {
    padding: 0;
    border: none;
  }
  && tbody > tr:hover > td {
    background: none;
  }
`;

export const StyledTableCellText = styled.div`
  margin: 0
    ${({ theme }) => `${theme.spacing.space_4} ${theme.spacing.space_4}`} 0;
`;

export const StyledHeader = styled.h3`
  margin-top: ${({ theme }) => theme.spacing.space_3};
`;

export const StyledParagraph = styled.p`
  margin: ${({ theme }) => theme.spacing.space_3} 0;
`;

export const StyledAppRadioGroup = styled(AppRadioGroup)`
  .ant-radio-button-wrapper {
    width: ${({ theme }) => theme.spacing.space_8};
    text-align: center;
  }
`;

export const StyledInfoCircleOutlined = styled(InfoCircleOutlined)`
  margin-left: ${({ theme }) => theme.spacing.space_2};
`;
